import { useTranslation } from 'react-i18next'

import { Box as DarkBox } from '@hivewatch/dark'

import { ConnectionI } from '../../types/types'
import { darkPopoverStyles } from './DarkFloorPlanPopover.styles'
import { getTailgatePopoverCopy } from './tailgatePopoverCopy'

interface DarkTailgatePopoverBodyIProps {
  colorScheme: 'dark' | 'light'
  connection: ConnectionI
}

/**
 * Dark twin of TailgatePopoverBody. The branch-per-state ladder moves to
 * getTailgatePopoverCopy so the body is a list render — the legacy version
 * repeats the same Text block five times with the copy inlined.
 */
export const DarkTailgatePopoverBody = ({
  colorScheme,
  connection,
}: DarkTailgatePopoverBodyIProps) => {
  const { t } = useTranslation()
  const s = darkPopoverStyles(colorScheme)
  const { bodyKeys } = getTailgatePopoverCopy(connection)

  return (
    <DarkBox {...s.bulletList}>
      {bodyKeys.map((key) => (
        <DarkBox key={key}>&#8226; {t(key)}</DarkBox>
      ))}
    </DarkBox>
  )
}
